import { useEffect, useMemo, useState } from 'react';
import { eventTypeService } from '@/services/api';
import { EventTypeResponse } from '@/types';
import { setDynamicEventTypes } from '@/utils/operational-ui.utils';

export const useEventTypes = () => {
  const [eventTypes, setEventTypes] = useState<EventTypeResponse[]>([]);
  const [loading, setLoading] = useState(false);

  const loadEventTypes = async () => {
    setLoading(true);
    try {
      const response = await eventTypeService.getAll();
      if (response.success && response.data) {
        setEventTypes(response.data);
        // Keep getEventStyles() in sync after create/edit (App only loads once on mount).
        setDynamicEventTypes(response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void loadEventTypes();
  }, []);

  const byCode = useMemo(() => {
    const map = new Map<string, EventTypeResponse>();
    for (const type of eventTypes) {
      map.set(type.code, type);
      map.set(type.code.toUpperCase(), type);
    }
    return map;
  }, [eventTypes]);

  return { eventTypes, eventTypesByCode: byCode, loading, reloadEventTypes: loadEventTypes };
};
